<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hWYkSw/tc-custom/9781466846340.jpg?1724412670274" alt="This image is the cover for the book Karen Memory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Karen Memory
      </h1>
      <p class="bookDescription body article font2">
        <b>“Bear pumps fresh energy in the steampunk genre with a light touch on the gadgetry and a vivid sense of place . . . Karen and the ladies kick ass.” —<i>Library Journal</i> (starred review)</b><br/><br/>Set in the late nineteenth century—when the city we now call Seattle Underground was the whole town (and still on the surface), when airships plied the trade routes, would-be gold miners were heading to the gold fields of Alaska, and steam-powered mechanicals stalked the waterfront, Karen Memery (“like memory only spelt with an e”) is a young woman on her own, making the best of her orphaned state by working in Madame Damnable’s high-quality bordello. Through Karen’s eyes we get to know the other girls in the house—a resourceful group—and the poor and the powerful of the town. Trouble erupts one night when a badly injured girl arrives at their door, begging for sanctuary, followed by the man who holds her indenture, and who has a machine that can take over anyone’s mind and control their actions. And as if that wasn’t bad enough, the next night brings a body dumped in their rubbish heap—a streetwalker who has been brutally murdered.<br/><br/>Bear brings alive this Jack-the-Ripper yarn of the old west with a light touch in Karen’s own memorable voice, and a mesmerizing evocation of classic steam-powered science.<br/><br/><b>“[A] rollicking, suspenseful, and sentimental steampunk novel . . . [Karen’s] story is a timeless one: a woman doing what is needed to get by while dreaming and fighting for great things to come.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Bear
      </h2>
      
      <p class="authorDescription body article">Elizabeth Bear was born on the same day as Frodo and Bilbo Baggins, but in a different year. She is the Hugo, Theodore Sturgeon Memorial, Locus, and Astounding Award&ndash;winning author of dozens of novels and over a hundred short stories. She has spoken on futurism at Google, MIT, DARPA&rsquo;s 100 Year Starship Project, and the White House, among others. Find her at www.elizabethbear.com.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43b0a658